import { useCallback, useContext, useRef } from 'react';
import { PageContext } from '../../store/page/context';

/**
 * Returns function that returns true if component is still on the page it was defined in CMS. Useful to prevent async calls and fetches on page change which may trigger on stale components due to our imperfect routing.
 * @returns {function(): boolean}
 */
export const useIsComponentStillOnItsPage = () => {
  const { page } = useContext(PageContext);
  const pagePathRef = useRef(page.pagePath);

  return useCallback(
    () => window.location.pathname.includes(pagePathRef.current),
    []
  );
};
